import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function exportCSV(data, filename) {
  if (!data?.length) return;
  const keys = Object.keys(data[0]);
  const csv = [
    keys.join(','),
    ...data.map(row => keys.map(k => `"${String(row[k] ?? '').replace(/"/g, '""')}"`).join(','))
  ].join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  triggerDownload(blob, `${filename}_${new Date().toISOString().slice(0, 10)}.csv`);
}

export function exportPDF(data, filename, title) {
  if (!data?.length) return;
  const doc = new jsPDF({ orientation: 'landscape' });
  const keys = Object.keys(data[0]);

  doc.setFontSize(14);
  doc.text(title || filename, 14, 15);
  doc.setFontSize(8);
  doc.text(`Export ${new Date().toLocaleDateString('fr-FR')}`, 14, 21);

  // Use standalone autoTable function for jspdf-autotable v5.0+
  autoTable(doc, {
    startY: 26,
    head: [keys],
    body: data.map(row => keys.map(k => String(row[k] ?? ''))),
    theme: 'grid',
    headStyles: { fillColor: [37, 99, 235], fontSize: 7 },
    bodyStyles: { fontSize: 7 },
    styles: { cellPadding: 2 },
  });

  doc.save(`${filename}_${new Date().toISOString().slice(0, 10)}.pdf`);
}

export async function exportChartPDF(elementRef, title, filename) {
  if (!elementRef) return;
  const canvas = await html2canvas(elementRef, {
    backgroundColor: '#18181b',
    scale: 2,
    useCORS: true,
    logging: false,
  });
  const imgData = canvas.toDataURL('image/png');
  const doc = new jsPDF({ orientation: 'landscape' });
  doc.setFontSize(14);
  doc.text(title || filename, 14, 15);
  doc.setFontSize(8);
  doc.text(`Export ${new Date().toLocaleDateString('fr-FR')}`, 14, 21);
  const pdfW = doc.internal.pageSize.getWidth() - 28;
  const pdfH = (canvas.height / canvas.width) * pdfW;
  doc.addImage(imgData, 'PNG', 14, 26, pdfW, Math.min(pdfH, 160));
  doc.save(`${filename}_${new Date().toISOString().slice(0, 10)}.pdf`);
}
